const filterParams = {
  agTextColumnFilter: {
    filterParams: {
      maxNumConditions: 1,
      filterOptions: ['contains', 'notContains', 'equals', 'notEqual', 'startsWith', 'endsWith']
    }
    // floatingFilter: true
  },
  agNumberColumnFilter: {
    filterParams: {
      maxNumConditions: 1,
      filterOptions: ['equals', 'notEqual', 'greaterThan', 'greaterThanOrEqual', 'lessThan', 'lessThanOrEqual', 'inRange']
    }
    // floatingFilter: true
  },
  agDateColumnFilter: {
    filterParams: {
      maxNumConditions: 1,
      filterOptions: ['equals', 'greaterThan', 'greaterThanOrEqual', 'lessThan', 'lessThanOrEqual', 'inRange']
    }
    // floatingFilter: true
  }
}

export default filterParams
